import * as React from "react";
import { Box, Paper, Backdrop, useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";

export default function LoadCard({ open, onClose, tittle }) {
  const theme = useTheme();
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      hideBackdrop={true}
    >
      <Paper
        elevation={1}
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          width: { xs: "80%", md: "50%", lg: "30%" },
          minHeight: "50%",
          boxShadow: 24,
          borderRadius: 1,
        }}
      >
        <Box
          height={50}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          backgroundColor="#00008B12"
        >
          <Typography variant="h6" id="modal-modal-title">
            Status
          </Typography>
        </Box>
        <Box
          height={250}
          display={"flex"}
          justifyContent={"center"}
          flexDirection={"column"}
          padding={1}
        >
          <Box>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: "5%",
              }}
            >
              <Typography textAlign={"center"}>
                {tittle ||
                  " Please Wait while your Transaction is Being Processed"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Modal>
  );
}
